import * as React from "react";

import { cn } from "@/lib/chillnn/cn";

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {}

/**
 * @todo 削除した時にrowsも減るようにする必要がある
 */
const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(({ className, ...props }, ref) => {
	const textAreaElement = document.querySelector("textarea");
	const textRowCount = textAreaElement ? textAreaElement.value.split("\n").length : 0;
	const rows = textRowCount + 1;

	return (
		<textarea
			className={cn(
				"flex min-h-[100px] w-full rounded-md border border-zinc-200 bg-white px-3 py-2 text-sm ring-offset-white",
				"placeholder:text-zinc-500/90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-black focus-visible:ring-offset-2",
				"disabled:cursor-not-allowed disabled:opacity-50",
				className,
			)}
			ref={ref}
			rows={rows}
			{...props}
		/>
	);
});
Textarea.displayName = "Textarea";

export { Textarea };
